import { useState } from 'react';

import chevronDown from '../../../../../assets/svgs/chevron_down-icon.svg';
import chevronUp from '../../../../../assets/svgs/chevron_up-icon.svg';
import notificationIcon from '../../../../../assets/svgs/notification-icon.svg';
import { CustomIcon } from '../../../../../components/widgets/CustomIcon';
import { NotificationSideBarProps } from '../types/notificationTypes';

export const NotificationSideBar = ({ options }: NotificationSideBarProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [dropDownIsOpen, setDropDownIsOpen] = useState(false);

  const optionsDefault = options
    ? options
    : [
        {
          name: 'Notificações',
          status: 'open',
          icon: <CustomIcon src={notificationIcon} />,
          options: [
            {
              name: 'Configurar notificação',
              link: '/corretor/notificacoes/configuracoes'
            },
            {
              name: 'Todas as notificações',
              link: '/corretor/notificacoes'
            }
          ]
        }
      ];

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className={`tw-flex tw-flex-col tw-h-auto tw-w-[14rem] tw-py-5 tw-bg-[#F8F8F8] tw-text-[#001E64] tw-font-bold tw-tw-text-[0.875rem]`}
    >
      {optionsDefault?.map((link, index) => {
        return (
          <div key={index} className="tw-flex tw-flex-col tw-justify-between">
            <div
              className="tw-flex tw-gap-[8px] tw-items-center tw-justify-between hover:tw-bg-[#E6F7FF] tw-py-3 tw-border-r-4 tw-border-transparent hover:tw-border-r-[#1890FF]  tw-cursor-pointer"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              onClick={() => setDropDownIsOpen(!dropDownIsOpen)}
            >
              <div
                className="tw-flex tw-gap-3 tw-px-6"
                style={{
                  color: isHovered ? '#146CFA' : '#001E64'
                }}
              >
                <span>{link.icon}</span>
                <span>{link.name}</span>
              </div>
              <button
                style={{
                  color: isHovered ? '#146CFA' : '#001E64'
                }}
              >
                <CustomIcon src={dropDownIsOpen ? chevronDown : chevronUp} />
              </button>
            </div>
            {dropDownIsOpen &&
              link.options.map((option, cont) => {
                return (
                  <button
                    key={cont}
                    className="tw-px-6 tw-py-3 hover:tw-bg-[#E6F7FF] hover:tw-text-[#146CFA] tw-border-r-4 tw-border-transparent hover:tw-border-r-[#1890FF] tw-cursor-pointer"
                    onClick={() => (window.location.pathname = option.link)}
                  >
                    <span>{option.name}</span>
                  </button>
                );
              })}
          </div>
        );
      })}
    </div>
  );
};
